//--------------- IMPORTAÇÕES ---------------//
import { loadProductsService, updateProductService } from "../../services";
import { ProdutosContext } from "../../context/ProdutosContext";
import { useContext, useEffect, useState } from "react";
import { toast } from "react-toastify";
import OfertasLastlinkPicker, { useOfertasLastlink, aplicarVinculosOfertas } from "../OfertasLastlinkPicker";



//------=--------- EXPORTAÇÕES ---------------//
export default function ModalEditProduct() {



    //--------------- CRIAÇÃO DE HOOKS ---------------//
    const { products, setProducts } = useContext(ProdutosContext); // Estado que armazena a lista de Produtos existentes
    const { isOpenModalEditProduct, setIsOpenModalEditProduct } = useContext(ProdutosContext); // Estado que armazena se o Modal de edição de Produto está aberto ou não
    const { formDataModalEditProduct, setFormDataModalEditProduct } = useContext(ProdutosContext); // Estado que armazena o Objeto Formulário do Modal de edição de Produto
    const ofertasLastlink = useOfertasLastlink();
    const [ofertasSelecionadas, setOfertasSelecionadas] = useState(new Set());
    useEffect(() => {
        setOfertasSelecionadas(new Set(ofertasLastlink.filter((o) => o.produto_id === formDataModalEditProduct.id).map((o) => o.id)));
    }, [ofertasLastlink, formDataModalEditProduct.id]);



    //--------------- FUNÇÃO ASSÍNCRONA CARREGAR PRODUTOS ---------------//
    // Responsável por requisitar à API os produtos existentes
    // Armazena no Estado "produtos" a lista de produtos retornadas pela API
    async function handleRefreshProducts() {
        const response = await loadProductsService();
        if (response) {
            setProducts(response.data);
        }
    };



    //--------------- FUNÇÃO ASSÍNCRONA SALVAR PRODUTO ---------------//
    // Responsável por salvar o Produto via API
    async function handleSaveProduct() {
        const response = await updateProductService(formDataModalEditProduct);
        if (response) {
            try { await aplicarVinculosOfertas(ofertasLastlink, formDataModalEditProduct.id, ofertasSelecionadas); }
            catch (e) { toast.error(e?.response?.data?.error || "Produto salvo, mas falhou ao vincular ofertas da Lastlink"); }
            setIsOpenModalEditProduct(false);
            handleRefreshProducts();
        }
    };



    //------------------ RETORNO CONDICIONAL DO MODAL ADD TAGS BULK ------------------//
    return (
        <>
            <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
                <div className="bg-surface-2 p-6 rounded-xl w-full max-w-lg border border-white/[0.08] max-h-[90vh] overflow-y-auto">
                    <h2 className="text-xl font-bold mb-4">Editar Produto</h2>
                    <input
                        type="text"
                        placeholder="Nome"
                        value={formDataModalEditProduct.nome || ""}
                        onChange={(e) => setFormDataModalEditProduct({ ...formDataModalEditProduct, nome: e.target.value })}
                        className="bg-surface-1 border border-white/[0.08] p-3 rounded text-white w-full mb-3"
                    />
                                        <p className="text-xs text-ink-3 mb-2">IDs nas plataformas — informe pelo menos um. Cadastre <b>antes da primeira venda</b> para o pixel/snippet do produto já ficar vinculado (o webhook casa a venda por esse ID).</p>
                    <div className="grid grid-cols-1 sm:grid-cols-3 gap-2 mb-3">
                        <div>
                            <label className="block text-xs text-ink-3 mb-1">ID Hotmart</label>
                            <input
                                type="text"
                                placeholder="ex.: 4821234"
                                value={formDataModalEditProduct.id_produto_hotmart || ""}
                                onChange={(e) => setFormDataModalEditProduct({ ...formDataModalEditProduct, id_produto_hotmart: e.target.value })}
                                className="bg-surface-1 border border-white/[0.08] p-3 rounded text-white w-full"
                            />
                        </div>
                        <div>
                            <label className="block text-xs text-ink-3 mb-1">ID Kiwify</label>
                            <input
                                type="text"
                                placeholder="ex.: 3a8f..."
                                value={formDataModalEditProduct.id_produto_kiwify || ""}
                                onChange={(e) => setFormDataModalEditProduct({ ...formDataModalEditProduct, id_produto_kiwify: e.target.value })}
                                className="bg-surface-1 border border-white/[0.08] p-3 rounded text-white w-full"
                            />
                        </div>
                        <div>
                            <label className="block text-xs text-ink-3 mb-1">ID Lastlink</label>
                            <input
                                type="text"
                                placeholder="uuid do produto"
                                value={formDataModalEditProduct.id_produto_lastlink || ""}
                                onChange={(e) => setFormDataModalEditProduct({ ...formDataModalEditProduct, id_produto_lastlink: e.target.value })}
                                className="bg-surface-1 border border-white/[0.08] p-3 rounded text-white w-full font-mono text-xs"
                            />
                        </div>
                    </div>

                    <OfertasLastlinkPicker ofertas={ofertasLastlink} selecionadas={ofertasSelecionadas} setSelecionadas={setOfertasSelecionadas} produtoId={formDataModalEditProduct.id} />

                    {/* Fase 2 — campos usados pelo agente IA como contexto do produto (RAG). */}
                    <label className="block text-xs text-ink-3 mb-1">Descrição do produto</label>
                    <textarea
                        placeholder="Resumo curto do produto (público-alvo, principal benefício, formato)"
                        value={formDataModalEditProduct.descricao || ""}
                        onChange={(e) => setFormDataModalEditProduct({ ...formDataModalEditProduct, descricao: e.target.value })}
                        className="bg-surface-1 border border-white/[0.08] p-3 rounded text-white text-sm w-full mb-3 min-h-[80px] resize-y"
                    />
                    <label className="block text-xs text-ink-3 mb-1">Conhecimento extra</label>
                    <textarea
                        placeholder="Informações detalhadas que o agente pode citar (ementa, módulos, garantias, FAQ rápido)"
                        value={formDataModalEditProduct.conhecimento_extra || ""}
                        onChange={(e) => setFormDataModalEditProduct({ ...formDataModalEditProduct, conhecimento_extra: e.target.value })}
                        className="bg-surface-1 border border-white/[0.08] p-3 rounded text-white text-sm w-full mb-4 min-h-[120px] resize-y"
                    />

                    <div className="flex justify-end gap-2">
                        <button
                            onClick={() => {
                                setFormDataModalEditProduct({ id: "", nome: "", id_produto_hotmart: "", id_produto_kiwify: "", id_produto_lastlink: "", descricao: "", conhecimento_extra: "" });
                                setIsOpenModalEditProduct(false);
                            }}
                            className="bg-surface-3 hover:bg-surface-4 px-4 py-2 rounded"
                        >
                            Cancelar
                        </button>
                        <button
                            onClick={handleSaveProduct}
                            className="bg-green-600 hover:bg-green-700 px-4 py-2 rounded"
                        >
                            Salvar
                        </button>
                    </div>
                </div>
            </div>
        </>
    )
}